import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as CrudServices from "../../../service/crudServices";
import { ChevronDownDDS } from "../../../asset";
import { Input } from "antd";
import changeToSentecesText from "../../../util/changeToSentecesText";

const DropdownSearchDepot = ({
  setValueDDS,
  children,
  valueDDS,
  className,
  togglerClassName,
  placeholder,
  filterBy,
  ...attrs
}) => {
  const { token } = useSelector((state) => state.auth);

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [params, setParams] = useState({ page: 1, limit: 100 });
  const [listData, setListData] = useState([]);
  const [dataSelected, setDataSelected] = useState();
  const [searchKeyword, setSearchkeyword] = useState("");

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const getListData = useCallback(
    async (newParams) => {
      const { ok, data } = await CrudServices.getList(
        token,
        `depot-configuration`,
        newParams
      );
      if (ok && data !== null && data.length !== 0) {
        const newData = data.map((el) => {
          return {
            id: el.depot_id,
            value: `${el.depot_name} - ${el.depot_address_1}`,
          };
        });
        if (!params.hasOwnProperty("filter") && !dataSelected) {
          setDataSelected(newData[0]);
          setValueDDS(newData[0]?.id);
        }

        setListData(newData);
      } else {
        setListData([]);
      }
    },
    [dataSelected, params, setValueDDS, token]
  );

  const onClickDataSelected = useCallback(
    (data) => {
      setDataSelected(data);
      setIsShowDropdownContent(false);
      setParams({ page: 1, limit: 100 });
      setSearchkeyword("");
      setValueDDS(data?.id);
    },
    [setValueDDS]
  );

  const onChangeSearch = useCallback(
    (val) => {
      if (!val) {
        const resetParams = { page: 1, limit: 100 };
        setParams(resetParams);
        setSearchkeyword("");
        return;
      }
      const newParams = {
        ...params,
        filter: `depot_name lk ${val}`,
      };
      setParams(newParams);
      setSearchkeyword(val);
    },
    [params]
  );

  useEffect(() => {
    getListData(params);
  }, [getListData, params]);

  return (
    <div
      className={"dropdown".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className="w-full border border-gray-200 bg-white-100 flex justify-between px-[6px] rounded-md h-full items-center"
        onClick={togglerDropdownContent}
      >
        <span
          className={"font-roboto text-xl text-black-300 font-medium px-2 truncate".concat(
            !dataSelected ? " text-opacity-50" : ""
          )}
        >
          {dataSelected
            ? changeToSentecesText(dataSelected?.value)
            : placeholder}
        </span>
        <img src={ChevronDownDDS} alt="img-chevron-down" />
      </button>
      <div></div>
      <div
        className={"dropdown-menu".concat(
          isShowDropdownContent ? " active mt-5" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="mt-2 px-2">
          <Input
            onChange={(evt) => {
              onChangeSearch(evt.target.value);
            }}
            value={searchKeyword}
            className="mb-2"
            placeholder="Search By Name Depot"
            size="large"
          />
        </div>
        <ul className="overflow-auto max-h-[300px]">
          {listData && listData.length !== 0 ? (
            listData.map((el, index) => (
              <li
                key={index}
                className="dropdown-item truncate"
                onClick={() => {
                  onClickDataSelected(el);
                }}
              >
                {changeToSentecesText(el?.value)}
              </li>
            ))
          ) : (
            <div className="flex w-full justify-center text-gray-600 font-bold text-base mb-5">
              No Data
            </div>
          )}
        </ul>
      </div>
    </div>
  );
};

export default DropdownSearchDepot;
